export class OrderReportReq {
  reportType: string;
  filterType: string;
  dateFrom: Date;
  dateTo: Date;
  employeee: string;
  deviceReplacementCount: number;
}
